import React from 'react';
import './Showcase.scss'

// import Swiper core and required modules
import { Navigation, Pagination, A11y, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
// Images
import nft1 from '../../Images/nft1.png'
import nft2 from '../../Images/nft2.png'
import nft3 from '../../Images/nft3.png'
import nft4 from '../../Images/nft4.png'
import nft5 from '../../Images/nft5.png'
import nft6 from '../../Images/nft6.png'
import nft7 from '../../Images/nft7.png'

function Showcase() {
  return (
    <div id='showcase'>
        <div className='row'>
            <div className='col-md-5'>
                <h2>What is the Space Ape Voyage?</h2>
            </div>

            <div className='col-md-2'></div>

            <div className='col-md-5'>
                <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quo ratione soluta et voluptatibus rerum ex eaque veritatis delectus voluptates assumenda, expedita nobis non accusamus, quis itaque veniam.</p>
            </div>
        </div>

        <Swiper
        modules={[Navigation, Pagination, A11y, Autoplay]}
        autoWidth={true}
        loop={true}
        slidesPerView={1.5}
        spaceBetween={50}
        breakpoints={{
            660: {
              slidesPerView: 2,
            },
            790: {
              slidesPerView: 3,
            },
            1200: {
              slidesPerView: 4,
            },
          }}
        pagination={{ clickable: true }}
        navigation={true}
        // centeredSlides={true}
        // watchSlidesProgress={true}
        autoplay={{
            delay: 2000,
            disableOnInteraction: false,
        }}
        className="mainSwiper"
        >
            <SwiperSlide><img className='nftSlide' src={nft5} alt="nft" /></SwiperSlide>
            <SwiperSlide><img className='nftSlide' src={nft1} alt="nft" /></SwiperSlide>
            <SwiperSlide><img className='nftSlide' src={nft3} alt="nft" /></SwiperSlide>
            <SwiperSlide><img className='nftSlide' src={nft4} alt="nft" /></SwiperSlide>
            <SwiperSlide><img className='nftSlide' src={nft2} alt="nft" /></SwiperSlide>
            <SwiperSlide><img className='nftSlide' src={nft6} alt="nft" /></SwiperSlide>
            <SwiperSlide><img className='nftSlide' src={nft7} alt="nft" /></SwiperSlide>
        </Swiper>
        
    </div>
  )
}

export default Showcase;
